<div class="multiSelect">
    <div
        class="multiSelectWrapper"
        [class.disabled]="false"
        [formGroup]="form"
        [ngClass]="{ open: showDropdown | async, top: dropdownTopPositioning }"
    >
        <input
            type="text"
            autocomplete="off"
            formControlName="searchInput"
            #multiSelectInput
            (blur)="closeOptionsList(); onTouched()"
            (clickOutside)="closeOptionsList()"
            (mousedown)="openOptionsList()"
            (keydown.space)="onSpaceKey($event)"
            (keydown.enter)="onEnterKey($event)"
            (keydown.arrowDown)="moveDown()"
            (keydown.arrowUp)="moveUp()"
        />
        @if (showDropdown | async) {
            <ul class="menuList card dropdownMenu" #dropdownMenu>
                @if ((showDropdown | async) && filteredAvailableOptionsList.length) {
                    @for (option of filteredAvailableOptionsList; track option.id || option.label; let i = $index) {
                        <li
                            class="noFixedWidth menuItemAuto"
                            #menuItemAuto
                            (mousemove)="mouseMove(i)"
                            (mousedown)="selectOption(filteredAvailableOptionsList[i], true, $event)"
                            [ngClass]="{ selected: i === selectedIndex, unselectable: option.unselectable }"
                            [innerHTML]="filteredAvailableOptionsList[i].label! | translate | highlight: multiSelectInput.value"
                        >
                            {{ option.label | translate }}
                        </li>
                    }
                } @else {
                    <li class="noFixedWidth menuItemAuto">
                        <span class="label">{{ 'multiselect.noOptions' | translate }}</span>
                    </li>
                }
            </ul>
        }
    </div>
    <div class="pillContainer">
        @if (selectedOptions && selectedOptions.length > 3) {
            <div>
                <div class="pill">
                    <span>{{ selectedOptions[0].label | translate }}</span>
                    @if (!enforceOneValue() || selectedOptions.length > 1) {
                        <button class="transparent icon fal fa-xmark" (click)="deselectOption(selectedOptions[0])"></button>
                    }
                </div>
                <div class="pill">
                    <span>{{ selectedOptions[1].label | translate }}</span>
                    <button class="transparent icon fal fa-xmark" (click)="deselectOption(selectedOptions[1])"></button>
                </div>
                <div class="link" (click)="openSelectedOptionsModal()">
                    <button class="transparent">{{ 'multiselect.showAll' | translate: { total: selectedOptions.length } }}</button>
                </div>
            </div>
        } @else {
            @for (option of selectedOptions; track option.id || option.label) {
                <div class="pill">
                    <span>{{ option.label | translate }}</span>
                    @if (!enforceOneValue() || selectedOptions.length > 1) {
                        <button class="transparent icon fal fa-xmark" (click)="deselectOption(option)"></button>
                    }
                </div>
            }
        }
    </div>
    @if (selectedOptions && selectedOptions.length > 1 && !enforceOneValue()) {
        <button class="button danger" type="button" (click)="deselectAll()">{{ 'multiselect.removeAll' | translate }}</button>
    }
</div>
